import React, { useState, useContext, useEffect } from 'react'
/* Mattlib */
import Dropdown from './Dropdown';
import RadioButtonsGroup from './RadioButtonsGroup'
import TextFields_Outlined from './TextFields_Outlined'
import TextFields_Outlined_Long from './TextFields_Outlined_Long'
import MultipleSelect_Checkbox from './MultiSelect_Checkbox'
import ProgressBar from './ProgressBar';
import MultiSelect_Checkbox_Outlined from './MultiSelect_Checkbox_Outlined'
import Dropdown_Advanced from './Dropdown_Advanced'
import Checkbox_Regular from './Checkbox_Regular';
import TextArea_Simple from './TextArea_Simple'
import YesOrNoCheckbox from './YesOrNoCheckbox'
import MySectionBlock from './MySectionBlock'
import ValidationModal from './ValidationModal';

/* Button */
import Button from '@material-ui/core/Button';
/* Grid */
import Grid from '@material-ui/core/Grid';
import { createTheme, ThemeProvider  } from "@material-ui/core";
/* Fade in */
import FadeIn from './FadeIn'
/* Data JSON */
import languages from '../data/languages.json'
import districts from '../data/districts.json'
import schools from '../data/schools.json'
import grades from '../data/grades.json'
import genders from '../data/genders.json'

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';


import ColumnStatus from './ColumnStatus'

/* Context */
import ContentContext from './ContentContext'
import { TranslationColumn1Context } from './TranslationContexts/TranslationColumn1Context'
import { useDispatch, useSelector } from 'react-redux'
import { page3ProgressBarUpdated, studentFirstName_bilUpdated, studentLastName_bilUpdated, countryOfOrigin_bilUpdated, DOB_bilUpdated, gender_bilUpdated, yearsInUS_bilUpdated, grade_bilUpdated, childResidesWith_bilUpdated, mfg1_bilUpdated, mfgName1_bilUpdated, mfg2_bilUpdated, mfgName2_bilUpdated, childsResidesWithOther_bilUpdated, homeAddress_bilUpdated, homeNum_bilUpdated, workNum_bilUpdated, cellNum_bilUpdated, nativeLanguage_bilUpdated, nativeLanguageOther_bilUpdated, districtDropdown_bilUpdated, schoolDropdown_bilUpdated, CSEDate_bilUpdated, currentTeacherName_bilUpdated, currentTeacherEmail_bilUpdated, psychologistName_bilUpdated, psychologistEmail_bilUpdated, speechPathologistName_bilUpdated, speechPathologistEmail_bilUpdated, districtContactName_bilUpdated, districtContactTitle_bilUpdated, districtContactAddress_bilUpdated, districtContactPhone_bilUpdated, districtContactEmail_bilUpdated, approverName_bilUpdated, approverTitle_bilUpdated, approverEmail_bilUpdated, coser_bilUpdated, reason_bilUpdated, alreadyClassified_bilUpdated, classification_bilUpdated, consentToEvalAttached_billUpdated, priorWrittenNoticeAttached_bilUpdated, homeLangQuestAttached_bilUpdated, nonVerbSecDiagnosed_bilUpdated, studentEnterSchoolDate_bilUpdated, nameOfOtherSchoolAttended_bilUpdated, typesOfEvals_bilUpdated, typesOfEvals_other_bilUpdated, diagnosedCondition_bilUpdated, diagnosedConditionText_bilUpdated, services_bilUpdated, generalHealth_bilUpdated, generalHealthText_bilUpdated, medication_bilUpdated, medicationText_bilUpdated, wearsGlasses_bilUpdated, wearsGlassesText_bilUpdated, pedRestrictions_bilUpdated, pedRestrictionsText_bilUpdated, physicalExamDate_bilUpdated, h_freq_audiology_bilUpdated, h_indv_audiology_bilUpdated, h_freq_visTherapy_bilUpdated, h_indv_visTherapy_bilUpdated, h_freq_resourceRoom_bilUpdated, h_indv_resourceRoom_bilUpdated, h_freq_counseling_bilUpdated, h_indv_counseling_bilUpdated, h_freq_speechLang_bilUpdated, h_indv_speechLang_bilUpdated, h_freq_physTherapy_bilUpdated, h_indv_physTherapy_bilUpdated, h_freq_occTherapy_bilUpdated, h_indv_occTherapy_bilUpdated, i_freq_Reading_bilUpdated, i_indv_Reading_bilUpdated, i_freq_AISMath_bilUpdated, i_indv_AISMath_bilUpdated, i_freq_AAtL_bilUpdated, i_indv_AAtL_bilUpdated, i_freq_AdjAssign_bilUpdated, i_indv_AdjAssign_bilUpdated, i_freq_schedAdj_bilUpdated, i_indv_schedAdj_bilUpdated, i_freq_indvProgBasedOnSkill_bilUpdated, i_indv_indvProgBasedOnSkill_bilUpdated, i_freq_speechImprov_bilUpdated, i_indv_speechImprov_bilUpdated, i_freq_tutoring_bilUpdated, i_indv_tutoring_bilUpdated, i_freq_consulServices_bilUpdated, i_indv_consulServices_bilUpdated, i_other_bilUpdated, areas_bilUpdated, addConcerns_bilUpdated, suspDetails_bilUpdated, notes_bilUpdated, docToAccessFiles_bilUpdated, consentToEvalAttachedFiles_bilUpdated, priorWrittenNoticeAttachedFiles_bilUpdated, homeLangQuestAttachedFiles_bilUpdated } from '../redux/slices/assessmentSlice'

/* Bootstrap */
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import 'bootstrap/dist/css/bootstrap.min.css';

/* Date Picker */
import DatePicker_Simple from './DatePicker_Simple'
import DatePicker_Advanced from './DatePicker_Advanced'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FcCalendar } from 'react-icons/fc';

// Context
import { useTranslation, useTranslationUpdate} from './TranslationContexts/TranslationDataContext'


const BilingualAssessmentContent_Page2 = ({ handleContinueButton, handleProgressBarChange }) => {
  const { contentState, setContentState } = useContext(ContentContext)
  //const { dataContext, setDataContext } = useContext(TranslationDataContext)

  const dispatch = useDispatch();
  const assessmentState = useSelector((state) => state.assessment); // Access translation state
  const [progressBarClass, setProgressBarClass] = useState('')

  const dataForQB = useTranslation()
  const setDataForQB = useTranslationUpdate()
  //const { dataForQB, setDataForQB } = useContext(TranslationDataContext)
  //alert(dataForQB.dueDateText+"data for qb")

  const useStyles = createTheme((theme) => ({
    root: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
  }));

  //const classes = makeStyles();

  const updateNonRequireField = (id, valueInInput) =>{
    dataForQB[id] = valueInInput
  }

  //////////////////////////////////////////////////////////////
  // COLUMN VALIDATION - UI TO SHOW THIS
  //////////////////////////////////////////////////////////////

  //////////////////////////////////////////////////////////////
  // Multiselects
  //////////////////////////////////////////////////////////////
  const [servicesTypes, setServicesTypes] = useState(dataForQB.services_bil); // new one for multi-select
  const handleServicesTypesChanges = (selectedTypes) => {
    setServicesTypes(selectedTypes);
    dataForQB["services_bil"] = selectedTypes;
  }
  const [typesOfEvalTypes, setTypesOfEvalTypes] = useState(dataForQB.typesOfEvals_bil); // new one for multi-select
  const handleTypesOfEvalTypesChanges = (selectedTypes) => {
    setTypesOfEvalTypes(selectedTypes);
    dataForQB["typesOfEvals_bil"] = selectedTypes;
  }
  const [diffInClassroomTypes, setDiffInClassroomTypes] = useState(dataForQB.areas_bil); // new one for multi-select
  const handleDiffInClassroomTypesChanges = (selectedTypes) => {
    setDiffInClassroomTypes(selectedTypes);
    dataForQB["areas_bil"] = selectedTypes;
  }
  

  //////////////////////////////////////////////////////////////

  //////////////////////////////////////////////////////////////
  // Column 2
  //////////////////////////////////////////////////////////////
  // States
  const [currentDistrict, setCurrentDistrict] = useState("")
  const [column2Complete, setColumn2Complete] = useState(false)
  const [renderOtherWhom, setRenderOtherWhom] = useState(false)
  const [col2RequiredFields, setCol2RequiredFields] = useState(
    {
      reason_bil: '',
      consentToEvalAttached_bill: '',
      priorWrittenNoticeAttached_bil: '',
      homeLangQuestAttached_bil: '',
      nonVerbSecDiagnosed_bil: '',
      studentEnterSchoolDate_bil: '',
      diagnosedCondition_bil: '',
      diagnosedConditionText_bil: '',
      services_bil: '',
      generalHealth_bil: '',
      generalHealthText_bil: '',
      medication_bil: '',
      medicationText_bil: '',
      wearsGlasses_bil: '',
      wearsGlassesText_bil: '',
      pedRestrictions_bil: '',
      pedRestrictionsText_bil: '',
      physicalExamDate_bil: '',
      areas_bil: '',
      addConcerns_bil: '',
      suspDetails_bil: ''

    }
  )

  const updateColumn2Count = (id, valueInInput) => {
    col2RequiredFields["reason_bil"] = dataForQB.reason_bil;
    col2RequiredFields["alreadyClassified_bil"] = dataForQB.alreadyClassified_bil;
    col2RequiredFields["classification_bil"] = dataForQB.classification_bil;
    col2RequiredFields["consentToEvalAttached_bill"] = dataForQB.consentToEvalAttached_bill;
    col2RequiredFields["priorWrittenNoticeAttached_bil"] = dataForQB.priorWrittenNoticeAttached_bil;
    col2RequiredFields["homeLangQuestAttached_bil"] = dataForQB.homeLangQuestAttached_bil;
    col2RequiredFields["nonVerbSecDiagnosed_bil"] = dataForQB.nonVerbSecDiagnosed_bil;
    col2RequiredFields["studentEnterSchoolDate_bil"] = dataForQB.studentEnterSchoolDate_bil;
    col2RequiredFields["nameOfOtherSchoolAttended_bil"] = dataForQB.nameOfOtherSchoolAttended_bil;
    col2RequiredFields["typesOfEvals_bil"] = dataForQB.typesOfEvals_bil;
    col2RequiredFields["diagnosedCondition_bil"] = dataForQB.diagnosedCondition_bil;
    col2RequiredFields["diagnosedConditionText_bil"] = dataForQB.diagnosedConditionText_bil;
    col2RequiredFields["services_bil"] = dataForQB.services_bil;
    col2RequiredFields["generalHealth_bil"] = dataForQB.generalHealth_bil;
    col2RequiredFields["generalHealthText_bil"] = dataForQB.generalHealthText_bil;
    col2RequiredFields["medication_bil"] = dataForQB.medication_bil;
    col2RequiredFields["medicationText_bil"] = dataForQB.medicationText_bil;
    col2RequiredFields["wearsGlasses_bil"] = dataForQB.wearsGlasses_bil;
    col2RequiredFields["wearsGlassesText_bil"] = dataForQB.wearsGlassesText_bil;
    col2RequiredFields["pedRestrictions_bil"] = dataForQB.pedRestrictions_bil;
    col2RequiredFields["pedRestrictionsText_bil"] = dataForQB.pedRestrictionsText_bil;
    col2RequiredFields["physicalExamDate_bil"] = dataForQB.physicalExamDate_bil;
    col2RequiredFields["h_freq_audiology_bil"] = dataForQB.h_freq_audiology_bil;
    col2RequiredFields["h_indv_audiology_bil"] = dataForQB.h_indv_audiology_bil;
    col2RequiredFields["h_freq_visTherapy_bil"] = dataForQB.h_freq_visTherapy_bil;
    col2RequiredFields["h_indv_visTherapy_bil"] = dataForQB.h_indv_visTherapy_bil;
    col2RequiredFields["h_freq_resourceRoom_bil"] = dataForQB.h_freq_resourceRoom_bil;
    col2RequiredFields["h_indv_resourceRoom_bil"] = dataForQB.h_indv_resourceRoom_bil;
    col2RequiredFields["h_freq_counseling_bil"] = dataForQB.h_freq_counseling_bil;
    col2RequiredFields["h_indv_counseling_bil"] = dataForQB.h_indv_counseling_bil;
    col2RequiredFields["h_freq_speechLang_bil"] = dataForQB.h_freq_speechLang_bil;
    col2RequiredFields["h_indv_speechLang_bil"] = dataForQB.h_indv_speechLang_bil;
    col2RequiredFields["h_freq_physTherapy_bil"] = dataForQB.h_freq_physTherapy_bil;
    col2RequiredFields["h_indv_physTherapy_bil"] = dataForQB.h_indv_physTherapy_bil;
    col2RequiredFields["h_freq_occTherapy_bil"] = dataForQB.h_freq_occTherapy_bil;
    col2RequiredFields["h_indv_occTherapy_bil"] = dataForQB.h_indv_occTherapy_bil;
    col2RequiredFields["i_freq_Reading_bil"] = dataForQB.i_freq_Reading_bil;
    col2RequiredFields["i_indv_Reading_bil"] = dataForQB.i_indv_Reading_bil;
    col2RequiredFields["i_freq_AISMath_bil"] = dataForQB.i_freq_AISMath_bil;
    col2RequiredFields["i_indv_AISMath_bil"] = dataForQB.i_indv_AISMath_bil;
    col2RequiredFields["i_freq_AAtL_bil"] = dataForQB.i_freq_AAtL_bil;
    col2RequiredFields["i_indv_AAtL_bil"] = dataForQB.i_indv_AAtL_bil;
    col2RequiredFields["i_freq_AdjAssign_bil"] = dataForQB.i_freq_AdjAssign_bil;
    col2RequiredFields["i_indv_AdjAssign_bil"] = dataForQB.i_indv_AdjAssign_bil;
    col2RequiredFields["i_freq_schedAdj_bil"] = dataForQB.i_freq_schedAdj_bil;
    col2RequiredFields["i_indv_schedAdj_bil"] = dataForQB.i_indv_schedAdj_bil;
    col2RequiredFields["i_freq_indvProgBasedOnSkill_bil"] = dataForQB.i_freq_indvProgBasedOnSkill_bil;
    col2RequiredFields["i_indv_indvProgBasedOnSkill_bil"] = dataForQB.i_indv_indvProgBasedOnSkill_bil;
    col2RequiredFields["i_freq_speechImprov_bil"] = dataForQB.i_freq_speechImprov_bil;
    col2RequiredFields["i_indv_speechImprov_bil"] = dataForQB.i_indv_speechImprov_bil;
    col2RequiredFields["i_freq_tutoring_bil"] = dataForQB.i_freq_tutoring_bil;
    col2RequiredFields["i_indv_tutoring_bil"] = dataForQB.i_indv_tutoring_bil;
    col2RequiredFields["i_freq_consulServices_bil"] = dataForQB.i_freq_consulServices_bil;
    col2RequiredFields["i_indv_consulServices_bil"] = dataForQB.i_indv_consulServices_bil;
    col2RequiredFields["i_other_bil"] = dataForQB.i_other_bil;
    col2RequiredFields["areas_bil"] = dataForQB.areas_bil;
    col2RequiredFields["addConcerns_bil"] = dataForQB.addConcerns_bil;
    col2RequiredFields["suspDetails_bil"] = dataForQB.suspDetails_bil;
    col2RequiredFields["notes_bil"] = dataForQB.notes_bil;
    let allFilledOut = true;
    for (var key in col2RequiredFields) {
      console.log("key " + key + " has value " + col2RequiredFields[key]);
      if (key == id) {
        col2RequiredFields[key] = valueInInput
        // Set the POST obj
      dataForQB[key] = valueInInput;
      }
      
      
    }
    if (id == "districtDropdown") {
      setCurrentDistrict(valueInInput)
      //setCurrentDistrict("Babylon")
    }

    // Top
    if(col2RequiredFields["reason_bil"] != "" &&
    //col2RequiredFields["alreadyClassified_bil"] == "" ||
    //(col2RequiredFields["consentToEvalAttached_bill"] == true || col2RequiredFields["consentToEvalAttached_bill"] == false) &&
    //(col2RequiredFields["priorWrittenNoticeAttached_bil"]  == true || col2RequiredFields["priorWrittenNoticeAttached_bil"] == false) &&
    //(col2RequiredFields["homeLangQuestAttached_bil"] == true || col2RequiredFields["homeLangQuestAttached_bil"] == false) &&
    //(col2RequiredFields["nonVerbSecDiagnosed_bil"] == true || col2RequiredFields["nonVerbSecDiagnosed_bil"] == false) &&
    col2RequiredFields["studentEnterSchoolDate_bil"] != "" &&
    col2RequiredFields["services_bil"] != "" &&

    (!col2RequiredFields.diagnosedCondition_bil || (col2RequiredFields["diagnosedConditionText_bil"] != "" && col2RequiredFields.diagnosedCondition_bil)) &&
    (!col2RequiredFields.generalHealth_bil || (col2RequiredFields["generalHealthText_bil"] != "" && col2RequiredFields.generalHealth_bil)) &&
    (!col2RequiredFields.medication_bil || (col2RequiredFields["medicationText_bil"] != "" && col2RequiredFields.medication_bil)) &&
    (!col2RequiredFields.wearsGlasses_bil || (col2RequiredFields["wearsGlassesText_bil"] != "" && col2RequiredFields.wearsGlasses_bil)) &&
    (!col2RequiredFields.pedRestrictions_bil || (col2RequiredFields["pedRestrictionsText_bil"] != "" && col2RequiredFields.pedRestrictions_bil)) &&
    
    col2RequiredFields["physicalExamDate_bil"] != "" &&
    
    col2RequiredFields["areas_bil"] != "" &&
    col2RequiredFields["suspDetails_bil"] != "") allFilledOut = true;
    else allFilledOut = false;
// Bottom
/*
// No
if (col2RequiredFields[key] == "" && col2RequiredFields[key]!=false) {
  console.log("NO: " + col2RequiredFields[key])
  allFilledOut = false;
}*/

    // THESE
    dataForQB.typesOfEvals_bil = typesOfEvalTypes;
    dataForQB.services_bil = servicesTypes;
    dataForQB.areas_bil = diffInClassroomTypes;

    setColumn2Complete(allFilledOut)
    setProgressBarDataInParent();

    console.log("-=-=-=-=-=-=-=-=-=-")
    console.log("QB DATA POST OBJECT CHANGED")
    console.log("-=-=-=-=-=-=-=-=-=-")
    console.log(dataForQB)
    console.log("-=-=-=-=-=-=-=-=-=-")
  }
  const renderColumn2ColumnStatus = () => {
    return <ColumnStatus complete={column2Complete} />
  }
  //////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////

  const handleThisContinueButton = function (newState) {
    handleContinueButton(newState)
  }
  

  function backToPreviousScreen(){
    dataForQB.intakeRunOnce = false
    dataForQB.assessmentRunOnce = false;
    handleThisContinueButton("assessmentPage2")
  }

  //const progressBarData = { bgcolor: "#00695c", completed: 0 }
  //const [progressBarPercent, setProgressBarPercent] = useState(0)

  const setProgressBarDataInParent = () => {
    let temp = 0;

    if (col2RequiredFields.services_bil != "") temp += 7;
    if (col2RequiredFields.reason_bil != "") temp += 7;
    if (!col2RequiredFields.consentToEvalAttached_bill || col2RequiredFields.consentToEvalAttached_bill) temp += 7;
    if (!col2RequiredFields.priorWrittenNoticeAttached_bil || col2RequiredFields.priorWrittenNoticeAttached_bil) temp += 7;
    if (!col2RequiredFields.homeLangQuestAttached_bil || col2RequiredFields.homeLangQuestAttached_bil) temp += 7;
    if (!col2RequiredFields.nonVerbSecDiagnosed_bil || col2RequiredFields.nonVerbSecDiagnosed_bil) temp += 7;
    if (col2RequiredFields.studentEnterSchoolDate_bil != "") temp += 7;
    if (!col2RequiredFields.diagnosedCondition_bil || col2RequiredFields.diagnosedConditionText_bil != "") temp += 7;
    if (!col2RequiredFields.generalHealth_bil || col2RequiredFields.generalHealthText_bil != "") temp += 7;
    if (!col2RequiredFields.medication_bil || col2RequiredFields.medicationText_bil != "") temp += 7;
    if (!col2RequiredFields.wearsGlasses_bil || col2RequiredFields.wearsGlassesText_bil != "") temp += 6;
    if (!col2RequiredFields.pedRestrictions_bil || col2RequiredFields.pedRestrictionsText_bil != "") temp += 6;
    if (col2RequiredFields.physicalExamDate_bil != "") temp += 6;
    //if (col2RequiredFields.i_other_bil != "") temp += 5;
    if (col2RequiredFields.areas_bil != "") temp += 6;
    if (col2RequiredFields.suspDetails_bil != "") temp += 6;

    handleProgressBarChange(parseInt(temp))
  }

  /* This is used for the inputs on the table that need to change their values and then call updateColumn2Count */
  const tableMapToReduxHelper = (e) =>{
    let id = e.target.id;
    let value = e.target.value;
    //col2RequiredFields[id] = value;
    // Now run the func that will add/subtract from the progress
    //updateColumn2Count();

    mapToRedux(id, value);
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setProgressBarDataInParent();
      //console.log(column1Complete, column2Complete);
    }, 100);
    return () => clearTimeout(timer);
  }, [column2Complete]);

  // Solution 1: Detect autofill and sync values to state
  useEffect(() => {
    const detectAndSyncAutofill = () => {
      // Get all input, textarea, and select elements in the form
      const inputs = document.querySelectorAll('input, textarea, select');
      let autofillDetected = false;

      inputs.forEach((input) => {
        // Skip MUI internal elements and elements without proper IDs
        if (!input.id || input.id.startsWith('mui-') || input.id.startsWith('react-select-')) {
          return;
        }

        // Check if input has a value but the corresponding state is empty
        if (input.value && input.id) {
          const stateValue = dataForQB[input.id];

          // If input has value but state is empty or doesn't match, sync it
          if (!stateValue || stateValue !== input.value) {
            autofillDetected = true;
            console.log(`Autofill detected for field: ${input.id}`);

            // Trigger update to sync the value
            if (input.id.startsWith('h_') || input.id.startsWith('i_')) {
              // Table inputs
              const event = { target: { id: input.id, value: input.value } };
              tableMapToReduxHelper(event);
            } else {
              // Regular inputs
              mapToRedux(input.id, input.value);
              updateColumn2Count(input.id, input.value);
            }
          }
        }
      });

      if (autofillDetected) {
        console.log('Autofill detected, revalidating form...');
        setTimeout(() => {
          updateColumn2Count();
          setProgressBarDataInParent();
        }, 100);
      }
    };

    // Check for autofill after a short delay (browsers apply autofill asynchronously)
    const timer1 = setTimeout(detectAndSyncAutofill, 500);
    const timer2 = setTimeout(detectAndSyncAutofill, 1000);
    const timer3 = setTimeout(detectAndSyncAutofill, 2000);

    // Also add input event listeners to detect autofill in real-time
    const handleInputEvent = (e) => {
      // Skip MUI internal elements
      if (!e.target.id || e.target.id.startsWith('mui-') || e.target.id.startsWith('react-select-')) {
        return;
      }

      if (e.target.id && e.target.value) {
        if (e.target.id.startsWith('h_') || e.target.id.startsWith('i_')) {
          tableMapToReduxHelper(e);
        } else {
          mapToRedux(e.target.id, e.target.value);
          updateColumn2Count(e.target.id, e.target.value);
        }
      }
    };

    // Add listeners to all inputs
    const inputs = document.querySelectorAll('input, textarea, select');
    inputs.forEach(input => {
      input.addEventListener('input', handleInputEvent);
    });

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
      inputs.forEach(input => {
        input.removeEventListener('input', handleInputEvent);
      });
    };
  }, []);

  //////////////////////////////////////////////////////////////
  //  Due Date
  //////////////////////////////////////////////////////////////
  const [startDueDate, setStartDueDate] = useState('')
  //////////////////////////////////////////////////////////////

  const [renderDiagnosedCondition, setRenderDiagnosedCondition] = useState(false)
  const [renderGeneralHealth, setGeneralHealth] = useState(false)
  const [renderMedication, setMedication] = useState(false)
  const [renderWearsGlasses, setWearsGlasses] = useState(false)
  const [renderPedRestrictions, setPedRestrictions] = useState(false)

  const [renderOtherType, setRenderOtherType] = useState(false)

  //////////////////////////////////////////////////////////////
  // Validations
  //////////////////////////////////////////////////////////////approver email
  const [validate_contactPhone, setValidation_contactPhone] = useState('')
  const [validate_contactEmail, setValidation_contactEmail] = useState('')
  const [validate_approverEmail, setValidation_approverEmail] = useState('')

  // Validation Modal State
  const [validationModalOpen, setValidationModalOpen] = useState(false);
  const [validationModalMissingFields, setValidationModalMissingFields] = useState([]);
  const [validationModalErrors, setValidationModalErrors] = useState([]);

  // Solution 3: Get list of missing required fields - check Redux state only
  const getMissingRequiredFields = () => {
    const missingFields = [];

    // Service(s) Selection
    if (!assessmentState.services_bil || assessmentState.services_bil === '' ||
        (Array.isArray(assessmentState.services_bil) && assessmentState.services_bil.length === 0)) {
      missingFields.push('Service(s) Selection');
    }

    // Section A - Reason for Referral
    if (!assessmentState.reason_bil || assessmentState.reason_bil === '') {
      missingFields.push('Reason for Referral (Section A)');
    }

    // Classification (conditional - required if student is already classified)
    if (assessmentState.alreadyClassified_bil && (!assessmentState.classification_bil || assessmentState.classification_bil === '')) {
      missingFields.push('Classification (Section A)');
    }

    // Section E - When Student Entered School District
    if (!assessmentState.studentEnterSchoolDate_bil || assessmentState.studentEnterSchoolDate_bil === '') {
      missingFields.push('When Student Entered School District (Section E)');
    }

    // Section G - Health (conditional fields)
    if (assessmentState.diagnosedCondition_bil && (!assessmentState.diagnosedConditionText_bil || assessmentState.diagnosedConditionText_bil === '')) {
      missingFields.push('Diagnosed Condition Details (Section G-1)');
    }

    if (assessmentState.generalHealth_bil && (!assessmentState.generalHealthText_bil || assessmentState.generalHealthText_bil === '')) {
      missingFields.push('General Health Details (Section G-2)');
    }

    if (assessmentState.medication_bil && (!assessmentState.medicationText_bil || assessmentState.medicationText_bil === '')) {
      missingFields.push('Medication Details (Section G-3)');
    }

    if (assessmentState.wearsGlasses_bil && (!assessmentState.wearsGlassesText_bil || assessmentState.wearsGlassesText_bil === '')) {
      missingFields.push('Wears Glasses Details (Section G-4)');
    }

    if (assessmentState.pedRestrictions_bil && (!assessmentState.pedRestrictionsText_bil || assessmentState.pedRestrictionsText_bil === '')) {
      missingFields.push('P/Ed Restrictions Details (Section G-5)');
    }

    // Section G-6 - Date of Last Physical Examination
    if (!assessmentState.physicalExamDate_bil || assessmentState.physicalExamDate_bil === '') {
      missingFields.push('Date of Last Physical Examination (Section G-6)');
    }

    // Section J - Areas of Difficulty in Classroom
    if (!assessmentState.areas_bil || assessmentState.areas_bil === '' ||
        (Array.isArray(assessmentState.areas_bil) && assessmentState.areas_bil.length === 0)) {
      missingFields.push('Areas of Difficulty in Classroom (Section J)');
    }

    // Section K - Suspension Details
    if (!assessmentState.suspDetails_bil || assessmentState.suspDetails_bil === '') {
      missingFields.push('Suspension Details (Section K)');
    }

    return missingFields;
  };

  // Solution 1 & 3: Function to sync DOM values to state before validation
  const syncDOMValuesToState = () => {
    const inputs = document.querySelectorAll('input, textarea, select');
    let syncedCount = 0;

    inputs.forEach((input) => {
      // Skip MUI internal elements
      if (!input.id || input.id.startsWith('mui-') || input.id.startsWith('react-select-')) {
        return;
      }

      if (input.id && input.value) {
        const stateValue = dataForQB[input.id];

        // If input has value but state is empty or doesn't match, sync it
        if (!stateValue || stateValue !== input.value) {
          console.log(`Syncing DOM value for: ${input.id} = ${input.value}`);
          syncedCount++;

          // Trigger update to sync the value
          if (input.id.startsWith('h_') || input.id.startsWith('i_')) {
            // Table inputs
            const event = { target: { id: input.id, value: input.value } };
            tableMapToReduxHelper(event);
          } else {
            // Regular inputs
            mapToRedux(input.id, input.value);
            updateColumn2Count(input.id, input.value);
          }
        }
      }
    });

    console.log(`Synced ${syncedCount} fields from DOM to state`);
    return syncedCount;
  };

  // Solution 3: Modified validation that checks DOM values and shows specific missing fields
  function runAllValidations (){
    // First, sync any DOM values that might not be in state (autofill scenario)
    const syncedCount = syncDOMValuesToState();

    // Function to check validation and provide feedback
    const checkAndProceed = () => {
      // Update the validation state
      updateColumn2Count();
      setProgressBarDataInParent();

      // Get list of missing fields
      const missingFields = getMissingRequiredFields();

      if (missingFields.length === 0) {
        // All fields complete, proceed
        dataForQB.assessmentRunOnce = false;
        handleThisContinueButton("approval-assessment");
      } else {
        // Show user which fields are missing via modal
        setValidationModalMissingFields(missingFields);
        setValidationModalErrors([]);
        setValidationModalOpen(true);
      }
    };

    if (syncedCount > 0) {
      console.log(`Synced ${syncedCount} autofilled fields before validation`);
      // Give a moment for state to update after sync
      setTimeout(checkAndProceed, 200);
    } else {
      // No sync needed, check immediately
      checkAndProceed();
    }
  }
  function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
  function validatePhone(phone)
  {
    var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    if(phone.match(phoneno)) return true;
    else return false;
  }



  if (!dataForQB.assessmentRunOnce){
    dataForQB.assessmentRunOnce = true;
    setTimeout(function(){
      //updateColumn1Count();
      //updateColumn2Count();
      //alert("RUNNNING")
      checkCol2AtStart();
    },500)
      console.log(col2RequiredFields)
  }
  const checkCol2AtStart = () =>{
    col2RequiredFields["reason_bil"] = dataForQB.reason_bil;
    col2RequiredFields["alreadyClassified_bil"] = dataForQB.alreadyClassified_bil;
    col2RequiredFields["classification_bil"] = dataForQB.classification_bil;
    col2RequiredFields["consentToEvalAttached_bill"] = dataForQB.consentToEvalAttached_bill;
    col2RequiredFields["priorWrittenNoticeAttached_bil"] = dataForQB.priorWrittenNoticeAttached_bil;
    col2RequiredFields["homeLangQuestAttached_bil"] = dataForQB.homeLangQuestAttached_bil;
    col2RequiredFields["nonVerbSecDiagnosed_bil"] = dataForQB.nonVerbSecDiagnosed_bil;
    col2RequiredFields["studentEnterSchoolDate_bil"] = dataForQB.studentEnterSchoolDate_bil;
    col2RequiredFields["nameOfOtherSchoolAttended_bil"] = dataForQB.nameOfOtherSchoolAttended_bil;
    col2RequiredFields["typesOfEvals_bil"] = dataForQB.typesOfEvals_bil;
    col2RequiredFields["diagnosedCondition_bil"] = dataForQB.diagnosedCondition_bil;
    col2RequiredFields["diagnosedConditionText_bil"] = dataForQB.diagnosedConditionText_bil;
    col2RequiredFields["services_bil"] = dataForQB.services_bil;
    col2RequiredFields["generalHealth_bil"] = dataForQB.generalHealth_bil;
    col2RequiredFields["generalHealthText_bil"] = dataForQB.generalHealthText_bil;
    col2RequiredFields["medication_bil"] = dataForQB.medication_bil;
    col2RequiredFields["medicationText_bil"] = dataForQB.medicationText_bil;
    col2RequiredFields["wearsGlasses_bil"] = dataForQB.wearsGlasses_bil;
    col2RequiredFields["wearsGlassesText_bil"] = dataForQB.wearsGlassesText_bil;
    col2RequiredFields["pedRestrictions_bil"] = dataForQB.pedRestrictions_bil;
    col2RequiredFields["pedRestrictionsText_bil"] = dataForQB.pedRestrictionsText_bil;
    col2RequiredFields["physicalExamDate_bil"] = dataForQB.physicalExamDate_bil;
    col2RequiredFields["h_freq_audiology_bil"] = dataForQB.h_freq_audiology_bil;
    col2RequiredFields["h_indv_audiology_bil"] = dataForQB.h_indv_audiology_bil;
    col2RequiredFields["h_freq_visTherapy_bil"] = dataForQB.h_freq_visTherapy_bil;
    col2RequiredFields["h_indv_visTherapy_bil"] = dataForQB.h_indv_visTherapy_bil;
    col2RequiredFields["h_freq_resourceRoom_bil"] = dataForQB.h_freq_resourceRoom_bil;
    col2RequiredFields["h_indv_resourceRoom_bil"] = dataForQB.h_indv_resourceRoom_bil;
    col2RequiredFields["h_freq_counseling_bil"] = dataForQB.h_freq_counseling_bil;
    col2RequiredFields["h_indv_counseling_bil"] = dataForQB.h_indv_counseling_bil;
    col2RequiredFields["h_freq_speechLang_bil"] = dataForQB.h_freq_speechLang_bil;
    col2RequiredFields["h_indv_speechLang_bil"] = dataForQB.h_indv_speechLang_bil;
    col2RequiredFields["h_freq_physTherapy_bil"] = dataForQB.h_freq_physTherapy_bil;
    col2RequiredFields["h_indv_physTherapy_bil"] = dataForQB.h_indv_physTherapy_bil;
    col2RequiredFields["h_freq_occTherapy_bil"] = dataForQB.h_freq_occTherapy_bil;
    col2RequiredFields["h_indv_occTherapy_bil"] = dataForQB.h_indv_occTherapy_bil;
    col2RequiredFields["i_freq_Reading_bil"] = dataForQB.i_freq_Reading_bil;
    col2RequiredFields["i_indv_Reading_bil"] = dataForQB.i_indv_Reading_bil;
    col2RequiredFields["i_freq_AISMath_bil"] = dataForQB.i_freq_AISMath_bil;
    col2RequiredFields["i_indv_AISMath_bil"] = dataForQB.i_indv_AISMath_bil;
    col2RequiredFields["i_freq_AAtL_bil"] = dataForQB.i_freq_AAtL_bil;
    col2RequiredFields["i_indv_AAtL_bil"] = dataForQB.i_indv_AAtL_bil;
    col2RequiredFields["i_freq_AdjAssign_bil"] = dataForQB.i_freq_AdjAssign_bil;
    col2RequiredFields["i_indv_AdjAssign_bil"] = dataForQB.i_indv_AdjAssign_bil;
    col2RequiredFields["i_freq_schedAdj_bil"] = dataForQB.i_freq_schedAdj_bil;
    col2RequiredFields["i_indv_schedAdj_bil"] = dataForQB.i_indv_schedAdj_bil;
    col2RequiredFields["i_freq_indvProgBasedOnSkill_bil"] = dataForQB.i_freq_indvProgBasedOnSkill_bil;
    col2RequiredFields["i_indv_indvProgBasedOnSkill_bil"] = dataForQB.i_indv_indvProgBasedOnSkill_bil;
    col2RequiredFields["i_freq_speechImprov_bil"] = dataForQB.i_freq_speechImprov_bil;
    col2RequiredFields["i_indv_speechImprov_bil"] = dataForQB.i_indv_speechImprov_bil;
    col2RequiredFields["i_freq_tutoring_bil"] = dataForQB.i_freq_tutoring_bil;
    col2RequiredFields["i_indv_tutoring_bil"] = dataForQB.i_indv_tutoring_bil;
    col2RequiredFields["i_freq_consulServices_bil"] = dataForQB.i_freq_consulServices_bil;
    col2RequiredFields["i_indv_consulServices_bil"] = dataForQB.i_indv_consulServices_bil;
    col2RequiredFields["i_other_bil"] = dataForQB.i_other_bil;
    col2RequiredFields["areas_bil"] = dataForQB.areas_bil;
    col2RequiredFields["addConcerns_bil"] = dataForQB.addConcerns_bil;
    col2RequiredFields["suspDetails_bil"] = dataForQB.suspDetails_bil;
    col2RequiredFields["notes_bil"] = dataForQB.notes_bil;
    var allFilledOut = true;
    for (var key in col2RequiredFields) {
      console.log("KEY: " + key)
      if (col2RequiredFields[key] == "") {
        console.log(col2RequiredFields[key] + "FAILED")
        allFilledOut = false;
      }
      
    }
    console.log("FILLED OUT: " + allFilledOut)
    setColumn2Complete(allFilledOut)
    setProgressBarDataInParent()
  }

  setTimeout(function(){
    updateColumn2Count();
    setProgressBarDataInParent();
  },500)
  //////////////////////////////////////////////////////////////
    // Scroll to relevant section of data entry on next page
    useEffect(() => {
      setTimeout(function(){window.scrollTo(0, 200)}, 400);
    }, []);
      //////////////////////////////////////////////////////////////
      // Mapping
      const mapToRedux = (id, valueInInput) => {
        switch (id) {
          case "services_bil":
            dispatch(services_bilUpdated(valueInInput))
            break;
          case "notes_bil":
            dispatch(notes_bilUpdated(valueInInput))
            break;
          case "reason_bil":
            dispatch(reason_bilUpdated(valueInInput))
            break;
          case "alreadyClassified_bil":
            dispatch(alreadyClassified_bilUpdated(valueInInput))
            break;
          case "classification_bil":
            dispatch(classification_bilUpdated(valueInInput))
            break;
          case "consentToEvalAttached_bill":
            dispatch(consentToEvalAttached_billUpdated(valueInInput))
            break;
          case "priorWrittenNoticeAttached_bil":
            dispatch(priorWrittenNoticeAttached_bilUpdated(valueInInput))
            break;
          case "homeLangQuestAttached_bil":
            dispatch(homeLangQuestAttached_bilUpdated(valueInInput))
            break;
          case "nonVerbSecDiagnosed_bil":
            dispatch(nonVerbSecDiagnosed_bilUpdated(valueInInput))
            break;
          case "studentEnterSchoolDate_bil":
            dispatch(studentEnterSchoolDate_bilUpdated(valueInInput))
            break;
          case "nameOfOtherSchoolAttended_bil":
            dispatch(nameOfOtherSchoolAttended_bilUpdated(valueInInput))
            break;
          case "typesOfEvals_bil":
            dispatch(typesOfEvals_bilUpdated(valueInInput))
            break;
          case "typesOfEvals_other_bil":
            dispatch(typesOfEvals_other_bilUpdated(valueInInput))
            break;
          case "diagnosedCondition_bil":
            dispatch(diagnosedCondition_bilUpdated(valueInInput))
            break;
          case "diagnosedConditionText_bil":
            dispatch(diagnosedConditionText_bilUpdated(valueInInput))
            break;

          case "generalHealth_bil":
            dispatch(generalHealth_bilUpdated(valueInInput))
            break;
          case "generalHealthText_bil":
            dispatch(generalHealthText_bilUpdated(valueInInput))
            break;
          case "medication_bil":
            dispatch(medication_bilUpdated(valueInInput))
            break;
          case "medicationText_bil":
            dispatch(medicationText_bilUpdated(valueInInput))
            break;
          case "wearsGlasses_bil":
            dispatch(wearsGlasses_bilUpdated(valueInInput))
            break;
          case "wearsGlassesText_bil":
            dispatch(wearsGlassesText_bilUpdated(valueInInput))
            break;
          case "pedRestrictions_bil":
            dispatch(pedRestrictions_bilUpdated(valueInInput))
            break;
          case "pedRestrictionsText_bil":
            dispatch(pedRestrictionsText_bilUpdated(valueInInput))
            break;
          case "physicalExamDate_bil":
            dispatch(physicalExamDate_bilUpdated(valueInInput.toISOString()))
            break;
          case "h_freq_audiology_bil":
            dispatch(h_freq_audiology_bilUpdated(valueInInput))
            break;
          case "h_indv_audiology_bil":
            dispatch(h_indv_audiology_bilUpdated(valueInInput))
            break;
          case "h_freq_visTherapy_bil":
            dispatch(h_freq_visTherapy_bilUpdated(valueInInput))
            break;
          case "h_indv_visTherapy_bil":
            dispatch(h_indv_visTherapy_bilUpdated(valueInInput))
            break;
          case "h_freq_resourceRoom_bil":
            dispatch(h_freq_resourceRoom_bilUpdated(valueInInput))
            break;
          case "h_indv_resourceRoom_bil":
            dispatch(h_indv_resourceRoom_bilUpdated(valueInInput))
            break;
          case "h_freq_counseling_bil":
            dispatch(h_freq_counseling_bilUpdated(valueInInput))
            break;
          case "h_indv_counseling_bil":
            dispatch(h_indv_counseling_bilUpdated(valueInInput))
            break;
          case "h_freq_speechLang_bil":
            dispatch(h_freq_speechLang_bilUpdated(valueInInput))
            break;
          case "h_indv_speechLang_bil":
            dispatch(h_indv_speechLang_bilUpdated(valueInInput))
            break;
          case "h_freq_physTherapy_bil":
            dispatch(h_freq_physTherapy_bilUpdated(valueInInput))
            break;
          case "h_indv_physTherapy_bil":
            dispatch(h_indv_physTherapy_bilUpdated(valueInInput))
            break;
          case "h_freq_occTherapy_bil":
            dispatch(h_freq_occTherapy_bilUpdated(valueInInput))
            break;
          case "h_indv_occTherapy_bil":
            dispatch(h_indv_occTherapy_bilUpdated(valueInInput))
            break;
          case "i_freq_Reading_bil":
            dispatch(i_freq_Reading_bilUpdated(valueInInput))
            break;
          case "i_indv_Reading_bil":
            dispatch(i_indv_Reading_bilUpdated(valueInInput))
            break;
          case "i_freq_AISMath_bil":
            dispatch(i_freq_AISMath_bilUpdated(valueInInput))
            break;
          case "i_indv_AISMath_bil":
            dispatch(i_indv_AISMath_bilUpdated(valueInInput))
            break;
          case "i_freq_AAtL_bil":
            dispatch(i_freq_AAtL_bilUpdated(valueInInput))
            break;
          case "i_indv_AAtL_bil":
            dispatch(i_indv_AAtL_bilUpdated(valueInInput))
            break;
          case "i_freq_AdjAssign_bil":
            dispatch(i_freq_AdjAssign_bilUpdated(valueInInput))
            break;
          case "i_indv_AdjAssign_bil":
            dispatch(i_indv_AdjAssign_bilUpdated(valueInInput))
            break;
          case "i_freq_schedAdj_bil":
            dispatch(i_freq_schedAdj_bilUpdated(valueInInput))
            break;
          case "i_indv_schedAdj_bil":
            dispatch(i_indv_schedAdj_bilUpdated(valueInInput))
            break;
          case "i_freq_indvProgBasedOnSkill_bil":
            dispatch(i_freq_indvProgBasedOnSkill_bilUpdated(valueInInput))
            break;
          case "i_indv_indvProgBasedOnSkill_bil":
            dispatch(i_indv_indvProgBasedOnSkill_bilUpdated(valueInInput))
            break;
          case "i_freq_speechImprov_bil":
            dispatch(i_freq_speechImprov_bilUpdated(valueInInput))
            break;
          case "i_indv_speechImprov_bil":
            dispatch(i_indv_speechImprov_bilUpdated(valueInInput))
            break;
          case "i_freq_tutoring_bil":
            dispatch(i_freq_tutoring_bilUpdated(valueInInput))
            break;
          case "i_indv_tutoring_bil":
            dispatch(i_indv_tutoring_bilUpdated(valueInInput))
            break;
          case "i_freq_consulServices_bil":
            dispatch(i_freq_consulServices_bilUpdated(valueInInput))
            break;
          case "i_indv_consulServices_bil":
            dispatch(i_indv_consulServices_bilUpdated(valueInInput))
            break;
          case "i_other_bil":
            dispatch(i_other_bilUpdated(valueInInput))
            break;
          case "areas_bil":
            dispatch(areas_bilUpdated(valueInInput))
            break;
          case "addConcerns_bil":
            dispatch(addConcerns_bilUpdated(valueInInput))
            break;
          case "suspDetails_bil":
            dispatch(suspDetails_bilUpdated(valueInInput))
            break;
          case "docToAccessFiles_bil":
            dispatch(docToAccessFiles_bilUpdated(valueInInput))
            break;
          case "consentToEvalAttachedFiles_bil":
            dispatch(consentToEvalAttachedFiles_bilUpdated(valueInInput))
            break;
          case "priorWrittenNoticeAttachedFiles_bil":
            dispatch(priorWrittenNoticeAttachedFiles_bilUpdated(valueInInput))
            break;
          case "homeLangQuestAttachedFiles_bil":
            dispatch(homeLangQuestAttachedFiles_bilUpdated(valueInInput))
            break;
          default:
            console.log("ID not found: " + id)
        }
      }
      //////////////////////////////////////////////////////////////

  return (
    <ThemeProvider theme={useStyles}>
      <ValidationModal
        open={validationModalOpen}
        onClose={() => setValidationModalOpen(false)}
        missingFields={validationModalMissingFields}
        validationErrors={validationModalErrors}
      />

      <div className='progress-bar-container'>
          <ProgressBar 
            key={0} 
            bgcolor={"#00695c"}
            completed={assessmentState.page3ProgressBar} 
            fixedClass={progressBarClass}
            isDisabed={false}
            runAllValidations={runAllValidations}
          />
          
          <MySectionBlock 
            height="5px" 
            onEnterViewport={() => {
                console.log('enter viewportttt')
                setProgressBarClass('')
            }}
            onLeaveViewport={() => {
                console.log('leave viewportttt')
                setProgressBarClass('progressBar-fixed')
            }}
          />
      </div>


    <div>{/* className={classes.root}>*/}
      <FadeIn delay={200} duration={450}>
          <Container fluid className="">
            {/* Content */}
            <Row>
              <Row>
                <Box style={{width: '60%', backgroundColor: '#F8F8F8', padding: '3px', marginBottom: '10px'}}>
                  <Card variant="outlined" style={{padding: '10px',}}>
                    <CardContent>
                {/* Left Column */}
                <Col>
                  {/*<Row>
                    
                    <Col>{renderColumn2ColumnStatus()}</Col>
                  </Row>*/}
                  {/*
                  <Row>
                    <Col><h4 className="content-section-title">Bilingual Assessment - Page 3/4</h4></Col>
                  </Row>
                  <Row><Col>&nbsp;</Col></Row>*/}
                  <Row>
                    {/*
                      <Col>
                      <p style={{border: "1px solid black", backgroundColor: '#396793', color: 'white', 
                        fontWeight: 'bold', padding: "4px", textAlign: "center"}}>SERVICE INFORMATION
                      </p>
                      </Col>
                      */}
                      <Col>
                        <p className="assessment-section-headers">SERVICE INFORMATION</p>
                      </Col>
                  </Row>
                  <Row>
                      <Col>
                        <p className='assessment-section-body' style={{fontWeight: 'bold'}}>
                          • Typically, Nassau BOCES bilingual evaluators conduct evaluations in the home. 
                            This facilitates the collection of data
                            from the family. If you prefer that the student be tested at the school, 
                            please contact our office to make
                            arrangements.
                          
                        </p>
                        <p className='assessment-section-body' style={{fontWeight: 'bold'}}>
                          • Consent forms and Prior Written Notice in parents'/guardians' native language must be <u>signed and attached</u>.
                        </p>
                      </Col>
                  </Row>
                  <Row><Col>&nbsp;</Col></Row>

                  {/* ROW 1 */}
                  <Row>
                      <Col>
                        <p className="assessment-section-headers">
                            Choose Your Service(s)
                        </p>
                      </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className='assessment-section-body'>
                        <b>Bilingual Assessment Services: (Please check all services requested):</b>
                        <MultiSelect_Checkbox_Outlined id="services_bil" 
                          classesToAdd={"required"}
                          valueInField={assessmentState.services_bil}
                          handleTranslationTypeChanges={handleServicesTypesChanges} 
                          triggerUpdateInParent={mapToRedux}
                          required={true}
                          label="" 
                          choices={["Psychological Evaluation", "Educational Evaluation", "Social History", 
                           "Speech-Language Evaluation", "New Entrant/K Screening", "Autism Diagnostic Observation Schedule (ADOS)"]} 
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <div className='assessment-section-body'>
                        <b>Notes:</b>
                      </div>
                      <div className='assessment-section-body'>
                        <TextArea_Simple id="notes_bil" 
                          classesToAdd={""}
                          required={false}
                          valueInField={assessmentState.notes_bil}
                          triggerUpdateInParent={mapToRedux}
                          placeholder="Please enter any notes you have, such as a services that is not listed above." 
                          rows={3} 
                          minrows={3} 
                          maxrows={5} 
                        />
                      </div>
                    </Col>
                  </Row>
                  
                  
                  <Row><Col>&nbsp;</Col></Row>

                  {/* ROW A */}
                  <Row>
                      <Col>
                        <p className="assessment-section-headers">
                            A: Reason for Referral (please be specific)
                        </p>
                      </Col>
                  </Row>
                  <Row>
                      <Col>
                          <div className='assessment-section-body'>
                            <TextArea_Simple id="reason_bil" 
                              classesToAdd={"required-adjusted-textarea-before"}
                              valueInField={assessmentState.reason_bil}
                              triggerUpdateInParent={mapToRedux}
                              placeholder="Enter reason here." 
                              required={true}
                              rows={3} minrows={3} maxrows={5}
                            />
                          </div>
                      </Col>
                  </Row>
                  <Row>
                      <Col>
                        <div className='assessment-section-body'>
                          <Checkbox_Regular id="alreadyClassified_bil" 
                            valueInField={assessmentState.alreadyClassified_bil}
                            required={false}
                            triggerUpdateInParent={mapToRedux}
                            label="Student is already classified"/>
                          <TextFields_Outlined id="classification_bil" 
                            valueInField={assessmentState.classification_bil}
                            triggerUpdateInParent={mapToRedux}
                            required={true} 
                            label="Classification" />
                        </div>
                      </Col>
                  </Row>

                  <Row><Col>&nbsp;</Col></Row>

                  {/* ROW B */}
                  <Row>
                      <Col>
                        <p className="assessment-section-headers">
                            B: Consent
                        </p>
                      </Col>
                  </Row>
                  <Row>
                      <Col>
                        <div className='assessment-section-body'>
                          <p>
                            <b>Will the Consent to Evaluate (native language) form be attached?</b>
                            <YesOrNoCheckbox id="consentToEvalAttached_bill" 
                              classesToAdd={"required-adjusted-yes-or-no-checkbox"}
                              valueInField={assessmentState.consentToEvalAttached_bill}
                              required={false}
                              triggerUpdateInParent={mapToRedux} 
                            />
                          </p>
                        </div>
                      </Col>
                  </Row>
                  <Row>
                      <Col>
                        <div className='assessment-section-body'>
                          <p>
                            <b>Will the Prior Written Notice be attached?</b>
                            <YesOrNoCheckbox id="priorWrittenNoticeAttached_bil" 
                              classesToAdd={"required-adjusted-yes-or-no-checkbox"}
                              valueInField={assessmentState.priorWrittenNoticeAttached_bil}
                              required={false}
                              triggerUpdateInParent={mapToRedux} 
                            />
                          </p>
                        </div>
                      </Col>
                  </Row>

                  {/* ROW C */}
                  <Row>
                      <Col>
                        <p className="assessment-section-headers">
                            C: Home Language
                        </p>
                      </Col>
                  </Row>
                  <Row>
                      <Col>
                        <div className='assessment-section-body'>
                        <p>
                          <b>Will the Home Language Questionnaire be attached?</b>
                          <YesOrNoCheckbox id="homeLangQuestAttached_bil" 
                            classesToAdd={"required-adjusted-yes-or-no-checkbox"}
                            valueInField={assessmentState.homeLangQuestAttached_bil}
                            required={false}
                            triggerUpdateInParent={mapToRedux} 
                          />
                        </p>
                        </div>
                      </Col>
                  </Row>


                  {/* ROW D */}
                  <Row>
                      <Col>
                        <p className="assessment-section-headers">
                            D: Non-Verbal
                        </p>
                      </Col>
                  </Row>
                  <Row>
                      <Col>
                        <div className='assessment-section-body'>
                        <p>
                          <b>Is the student non-verbal secondary to a diagnosed condition?</b>
                          <YesOrNoCheckbox id="nonVerbSecDiagnosed_bil" 
                            classesToAdd={"required-adjusted-yes-or-no-checkbox"}
                            valueInField={assessmentState.nonVerbSecDiagnosed_bil}
                            required={false}
                            triggerUpdateInParent={mapToRedux} 
                          />
                        </p>
                        </div>
                      </Col>
                  </Row>

                  {/* ROW E */}
                  <Row>
                      <Col>
                        <p className="assessment-section-headers">
                            E: Schools Attended
                        </p>
                      </Col>
                  </Row>
                  <Row>
                      <Col>
                        <div className='assessment-section-body'>
                          <Col>
                          <p><b>When did the student enter your school district?</b></p>
                          </Col>
                          <Col>
                          {/*<TextFields_Outlined required={true} triggerUpdateInParent={updateColumn2Count} id="eaText" label="Required" />*/}
                          <TextFields_Outlined id="studentEnterSchoolDate_bil" 
                            classesToAdd={"required-adjusted-lower"}
                            valueInField={assessmentState.studentEnterSchoolDate_bil}
                            triggerUpdateInParent={mapToRedux}
                            required={true}
                            label="Enter date or grade"
                          />
                          </Col>
                          <Col>&nbsp;</Col>
                        </div>
                        <div className='assessment-section-body'>
                          <Col>
                            <p>
                              <b>Names of other school district(s) attended?</b>
                            </p>
                          </Col>
                          <Col>
                            <TextFields_Outlined_Long id="nameOfOtherSchoolAttended_bil" 
                              valueInField={assessmentState.nameOfOtherSchoolAttended_bil}
                              paddingLeft= "40px" 
                              required={false}
                              triggerUpdateInParent={mapToRedux} 
                              label="If Applicable" 
                            />
                          </Col>
                          <Col>&nbsp;</Col>
                        </div>
                      </Col>
                  </Row>

                  {/* ROW F */}
                  <Row>
                      <Col>
                        <p className="assessment-section-headers">
                            F: Previous Evaluations
                        </p>
                        <div className='assessment-section-body'>
                          <MultiSelect_Checkbox_Outlined id="typesOfEvals_bil" 
                            classesToAdd={""}
                            valueInField={assessmentState.typesOfEvals_bil}
                            triggerUpdateInParent={mapToRedux}
                            handleTranslationTypeChanges={handleTypesOfEvalTypesChanges} 
                            renderOther={setRenderOtherType} 
                            required={false}
                            label="Type(s) of evaluation" 
                            choices={["Bilingual Psychological", "Bilingual Educational", "Bilingual Speech Language", "Other"]} 
                          />
                        </div>
                        {
                          renderOtherType && <div className='assessment-section-body'>
                          <TextArea_Simple id="typesOfEvals_other_bil" 
                            classesToAdd={""}
                            valueInField={assessmentState.typesOfEvals_other_bil}
                            triggerUpdateInParent={mapToRedux}
                            placeholder="Other type of evaluation(s) here." 
                            required={false}
                            rows={3} 
                            minrows={3} 
                            maxrows={5} />
                        </div>
                        /*<br/>*/
                          /*<TextFields_Outlined_Long id="typesOfEvals_other_bil" valueInField={dataForQB.typesOfEvals_other_bil} paddingLeft= "40px" triggerUpdateInParent={updateNonRequireField} label="Other Evaluation" />*/
                        }
                        
                      </Col>
                  </Row>

                  {/* ROW G */}
                  <Row>
                      <Col>
                      <p className="assessment-section-headers">
                            G: Health
                        </p>
                      </Col>
                  </Row>
                  {/* Prompt */}
                  <p className='assessment-section-body'><b style={{color:'red'}}>*If you do not know the answer to any of the following questions, please put unsure.</b></p> 
                  <p className='assessment-section-body'><b style={{color:'red'}}>*If an option does not require an answer, please put n/a.</b></p> 
                  {/* G-1 */}
                  <Row>
                      <Col>
                        <div className='assessment-section-body'>
                          <Col>
                              <b>1) Does the student have a diagnosed condition?</b>
                              <YesOrNoCheckbox id="diagnosedCondition_bil" 
                                classesToAdd={"required-adjusted-yes-or-no-checkbox"}
                                valueInField={assessmentState.diagnosedCondition_bil}
                                renderOther={setRenderDiagnosedCondition} 
                                triggerUpdateInParent={mapToRedux} 
                              />
                          </Col>
                          <Col>
                            {
                              renderDiagnosedCondition &&
                                <TextFields_Outlined_Long id="diagnosedConditionText_bil" 
                                classesToAdd={"required-adjusted-lower"}
                                valueInField={assessmentState.diagnosedConditionText_bil}
                                required={true} 
                                triggerUpdateInParent={mapToRedux}  
                                label="Condition (required)" 
                              />
                            }
                          </Col>
                          <Col>&nbsp;</Col>
                        </div>
                      </Col>
                  </Row>
                  {/* G-2 */}
                  <Row>
                      <Col>
                        <div className='assessment-section-body'>
                          <Col>
                              <b>2) General Health</b>
                              <YesOrNoCheckbox id="generalHealth_bil" 
                                classesToAdd={"required-adjusted-yes-or-no-checkbox"}
                                valueInField={assessmentState.generalHealth_bil}
                                renderOther={setGeneralHealth} 
                                altLabel1="Good" 
                                altLabel2="Other" 
                                triggerUpdateInParent={mapToRedux} 
                              />
                          </Col>
                          <Col>
                          {
                            renderGeneralHealth &&
                            <TextFields_Outlined_Long id="generalHealthText_bil"
                              classesToAdd={"required-adjusted-lower"}
                              valueInField={assessmentState.generalHealthText_bil}
                             required={true} 
                             triggerUpdateInParent={mapToRedux} 
                             label="Other (required)" 
                            />
                          }
                          </Col>
                          <Col>&nbsp;</Col>
                        </div>
                      </Col>
                  </Row>
                  {/* G-3 */}
                  <Row>
                      <Col>
                        <div className='assessment-section-body'>
                          <Col>
                              <b>3) Medication</b>
                              <YesOrNoCheckbox id="medication_bil" 
                                classesToAdd={"required-adjusted-yes-or-no-checkbox"}
                                valueInField={assessmentState.medication_bil}
                                renderOther={setMedication} 
                                altLabel1="" 
                                altLabel2="" 
                                triggerUpdateInParent={mapToRedux} 
                              />
                          </Col>
                          <Col>
                          {
                            renderMedication &&
                            <TextFields_Outlined_Long id="medicationText_bil" 
                              classesToAdd={"required-adjusted-lower"}
                              valueInField={assessmentState.medicationText_bil}
                              required={true} 
                              triggerUpdateInParent={mapToRedux}  
                              label="Comments (required)" 
                            />
                          }
                          </Col>
                          <Col>&nbsp;</Col>
                        </div>
                      </Col>
                  </Row>
                  {/* G-4 */}
                  <Row>
                      <Col>
                        <div className='assessment-section-body'>
                          <Col>
                            <b>4) Wears Glasses</b>
                            <YesOrNoCheckbox id="wearsGlasses_bil" 
                              classesToAdd={"required-adjusted-yes-or-no-checkbox"}
                              valueInField={assessmentState.wearsGlasses_bil}
                              renderOther={setWearsGlasses} 
                              altLabel1="" 
                              altLabel2="" 
                              triggerUpdateInParent={mapToRedux} 
                            />
                          </Col>
                          <Col>
                          {
                            renderWearsGlasses &&
                            <TextFields_Outlined_Long id="wearsGlassesText_bil" 
                              classesToAdd={"required-adjusted-lower"}
                              valueInField={assessmentState.wearsGlassesText_bil}
                              required={true} 
                              triggerUpdateInParent={mapToRedux} 
                              label="Comments (required)" 
                            />
                          }
                          </Col>
                          <Col>&nbsp;</Col>
                        </div>
                      </Col>
                  </Row>
                  {/* G-5 */}
                  <Row>
                      <Col>
                        <div className='assessment-section-body'>
                          <Col>
                              <b>5) P/Ed Restrictions</b>
                              <YesOrNoCheckbox id="pedRestrictions_bil" 
                                classesToAdd={"required-adjusted-yes-or-no-checkbox"}
                                valueInField={assessmentState.pedRestrictions_bil}
                                renderOther={setPedRestrictions} 
                                altLabel1="" 
                                altLabel2="" 
                                triggerUpdateInParent={mapToRedux} 
                              />
                          </Col>
                          <Col>
                          {
                            renderPedRestrictions &&
                            <TextFields_Outlined_Long id="pedRestrictionsText_bil" 
                              classesToAdd={"required-adjusted-lower"}
                              valueInField={assessmentState.pedRestrictionsText_bil}
                              required={true} 
                              triggerUpdateInParent={mapToRedux} 
                              label="Comments (required)" 
                            />
                          }
                          </Col>
                          <Col>&nbsp;</Col>
                        </div>
                      </Col>
                  </Row>
                  {/* G-6 */}
                  <Row>
                      <Col>
                        <div className='assessment-section-body'>
                          <Col>
                              <b>6) Date of Last Physical Examination</b>
                            
                            <DatePicker_Advanced valueInField={assessmentState.physicalExamDate_bil} 
                              classesToAdd={"required-adjusted-date"} 
                              triggerUpdateInParent={mapToRedux} 
                              id="physicalExamDate_bil" 
                              className="date-picker-main" 
                              maxDate={new Date()}
                              label="Exam Date" 
                              selected={startDueDate} 
                              required={true}
                              onChange={date => setStartDueDate(date)} 
                            />
                          </Col>
                          <Col>&nbsp;</Col>
                          
                        </div>
                      </Col>
                  </Row>

                  {/* ROW H */}
                  <Row>
                      <Col>
                      <p className="assessment-section-headers">
                            H: Intervention/Services
                        </p>
                        <table className="assessment-service-table">
                          {/* Header */}
                          <tr>
                            <th>
                              Intervention
                            </th>
                            <th>
                              Frequency
                            </th>
                            <th>
                              Individual (I) or Group (G)
                            </th>
                          </tr>
                          {/* Row 0 */}
                          <tr>
                            <td>
                              Audiology
                            </td>
                            <td>
                              <input defaultValue={assessmentState.h_freq_audiology_bil} placeholder="Enter text here" 
                                      type="text" onBlur={tableMapToReduxHelper} className id="h_freq_audiology_bil"></input>
                            </td>
                            <td>
                              <input defaultValue={assessmentState.h_indv_audiology_bil} placeholder="Enter text here" 
                                      type="text" onBlur={tableMapToReduxHelper} id="h_indv_audiology_bil"></input>
                            </td>
                          </tr>
                          {/* Row 1 */}
                          <tr>
                            <td>
                              Vision Therapy
                            </td>
                            <td>
                              <input defaultValue={assessmentState.h_freq_visTherapy_bil} placeholder="Enter text here" 
                                      type="text" onBlur={tableMapToReduxHelper} className id="h_freq_visTherapy_bil"></input>
                            </td>
                            <td>
                              <input defaultValue={assessmentState.h_indv_visTherapy_bil} placeholder="Enter text here" 
                                      type="text" onBlur={tableMapToReduxHelper} id="h_indv_visTherapy_bil"></input>
                            </td>
                          </tr>
                          {/* Row 2 */}
                          <tr>
                            <td>
                              Resource Room
                            </td>
                            <td>
                              <input defaultValue={assessmentState.h_freq_resourceRoom_bil} placeholder="Enter text here" 
                                      type="text" onBlur={tableMapToReduxHelper} className id="h_freq_resourceRoom_bil"></input>
                            </td>
                            <td>
                              <input defaultValue={assessmentState.h_indv_resourceRoom_bil} placeholder="Enter text here" 
                                      type="text" onBlur={tableMapToReduxHelper} id="h_indv_resourceRoom_bil"></input>
                            </td>
                          </tr>
                          {/* Row 3 */}
                          <tr>
                            <td>
                              Counseling
                            </td>
                            <td>
                              <input defaultValue={assessmentState.h_freq_counseling_bil} placeholder="Enter text here" 
                                      type="text" onBlur={tableMapToReduxHelper} className id="h_freq_counseling_bil"></input>
                            </td>
                            <td>
                              <input defaultValue={assessmentState.h_indv_counseling_bil} placeholder="Enter text here" 
                                      type="text" onBlur={tableMapToReduxHelper} id="h_indv_counseling_bil"></input>
                            </td>
                          </tr>
                          {/* Row 4 */}
                          <tr>
                            <td>
                              Speech-Language Therapy
                            </td>
                            <td>
                              <input defaultValue={assessmentState.h_freq_speechLang_bil} placeholder="Enter text here" 
                                      type="text" onBlur={tableMapToReduxHelper} className id="h_freq_speechLang_bil"></input>
                            </td>
                            <td>
                              <input defaultValue={assessmentState.h_indv_speechLang_bil} placeholder="Enter text here" 
                                      type="text" onBlur={tableMapToReduxHelper} id="h_indv_speechLang_bil"></input>
                            </td>
                          </tr>
                          {/* Row 5 */}
                          <tr>
                            <td>
                              Physical Therapy
                            </td>
                            <td>
                              <input defaultValue={assessmentState.h_freq_physTherapy_bil} placeholder="Enter text here" 
                                      type="text" onBlur={tableMapToReduxHelper} className id="h_freq_physTherapy_bil"></input>
                            </td>
                            <td>
                              <input defaultValue={assessmentState.h_indv_physTherapy_bil} placeholder="Enter text here" 
                                      type="text" onBlur={tableMapToReduxHelper} id="h_indv_physTherapy_bil"></input>
                            </td>
                          </tr>
                          {/* Row 6 */}
                          <tr>
                            <td>
                              Occupational Therapy
                            </td>
                            <td>
                              <input defaultValue={assessmentState.h_freq_occTherapy_bil} placeholder="Enter text here" 
                                      type="text" onBlur={tableMapToReduxHelper} className id="h_freq_occTherapy_bil"></input>
                            </td>
                            <td>
                              <input defaultValue={assessmentState.h_indv_occTherapy_bil} placeholder="Enter text here" 
                                      type="text" onBlur={tableMapToReduxHelper} id="h_indv_occTherapy_bil"></input>
                            </td>
                          </tr>
                        </table>
                        <br/>
                      </Col>
                  </Row>

                  {/* ROW I */}
                  <Row>
                      <Col>
                      <p className="assessment-section-headers">
                            I: Other Interventions
                        </p>
                        <table className="assessment-service-table">
                          {/* Header */}
                          <tr>
                            <th>
                              Intervention
                            </th>
                            <th>
                              Frequency
                            </th>
                            <th>
                              Individual (I) or Group (G)
                            </th>
                          </tr>
                          {/* Row 0 */}
                          <tr>
                            <td>
                              AIS - Reading
                            </td>
                            <td>
                              <input defaultValue={assessmentState.i_freq_Reading_bil} placeholder="Enter text here" 
                                      type="text" onBlur={tableMapToReduxHelper} className id="i_freq_Reading_bil"></input>
                            </td>
                            <td>
                              <input defaultValue={assessmentState.i_indv_Reading_bil} placeholder="Enter text here" 
                                      type="text" onBlur={tableMapToReduxHelper} id="i_indv_Reading_bil"></input>
                            </td>
                          </tr>
                          {/* Row 1 */}
                          <tr>
                            <td>
                              AIS - Math
                            </td>
                            <td>
                              <input defaultValue={assessmentState.i_freq_AISMath_bil} placeholder="Enter text here" 
                                      type="text" onBlur={tableMapToReduxHelper} className id="i_freq_AISMath_bil"></input>
                            </td>
                            <td>
                              <input defaultValue={assessmentState.i_indv_AISMath_bil} placeholder="Enter text here" 
                                      type="text" onBlur={tableMapToReduxHelper} id="i_indv_AISMath_bil"></input>
                            </td>
                          </tr>
                          {/* Row 2 */}
                          <tr>
                            <td>
                              Alternative Approaches to Learning
                            </td>
                            <td>
                              <input defaultValue={assessmentState.i_freq_AAtL_bil} placeholder="Enter text here" 
                                      type="text" onBlur={tableMapToReduxHelper} className id="i_freq_AAtL_bil"></input>
                            </td>
                            <td>
                              <input defaultValue={assessmentState.i_indv_AAtL_bil} placeholder="Enter text here" 
                                      type="text" onBlur={tableMapToReduxHelper} id="i_indv_AAtL_bil"></input>
                            </td>
                          </tr>
                          {/* Row 3 */}
                          <tr>
                            <td>
                              Adjusted Assignments (e.g. fewer)
                            </td>
                            <td>
                              <input defaultValue={assessmentState.i_freq_AdjAssign_bil} placeholder="Enter text here" 
                                      type="text" onBlur={tableMapToReduxHelper} className id="i_freq_AdjAssign_bil"></input>
                            </td>
                            <td>
                              <input defaultValue={assessmentState.i_indv_AdjAssign_bil} placeholder="Enter text here" 
                                      type="text" onBlur={tableMapToReduxHelper} id="i_indv_AdjAssign_bil"></input>
                            </td>
                          </tr>
                          {/* Row 4 */}
                          <tr>
                            <td>
                              Schedule Adjustments
                            </td>
                            <td>
                              <input defaultValue={assessmentState.i_freq_schedAdj_bil} placeholder="Enter text here" 
                                      type="text" onBlur={tableMapToReduxHelper} className id="i_freq_schedAdj_bil"></input>
                            </td>
                            <td>
                              <input defaultValue={assessmentState.i_indv_schedAdj_bil} placeholder="Enter text here" 
                                      type="text" onBlur={tableMapToReduxHelper} id="i_indv_schedAdj_bil"></input>
                            </td>
                          </tr>
                          {/* Row 5 */}
                          <tr>
                            <td>
                              Individualized Program Based on Skill Level
                            </td>
                            <td>
                              <input defaultValue={assessmentState.i_freq_indvProgBasedOnSkill_bil} placeholder="Enter text here" 
                                      type="text" onBlur={tableMapToReduxHelper} className id="i_freq_indvProgBasedOnSkill_bil"></input>
                            </td>
                            <td>
                              <input defaultValue={assessmentState.i_indv_indvProgBasedOnSkill_bil} placeholder="Enter text here" 
                                      type="text" onBlur={tableMapToReduxHelper} id="i_indv_indvProgBasedOnSkill_bil"></input>
                            </td>
                          </tr>
                          {/* Row 6 */}
                          <tr>
                            <td>
                              Speech Improvement (ERSS)
                            </td>
                            <td>
                              <input defaultValue={assessmentState.i_freq_speechImprov_bil} placeholder="Enter text here" 
                                      type="text" onBlur={tableMapToReduxHelper} className id="i_freq_speechImprov_bil"></input>
                            </td>
                            <td>
                              <input defaultValue={assessmentState.i_indv_speechImprov_bil} placeholder="Enter text here" 
                                      type="text" onBlur={tableMapToReduxHelper} id="i_indv_speechImprov_bil"></input>
                            </td>
                          </tr>
                          {/* Row 7 */}
                          <tr>
                            <td>
                              Tutoring
                            </td>
                            <td>
                              <input defaultValue={assessmentState.i_freq_tutoring_bil} placeholder="Enter text here" 
                                      type="text" onBlur={tableMapToReduxHelper} className id="i_freq_tutoring_bil"></input>
                            </td>
                            <td>
                              <input defaultValue={assessmentState.i_indv_tutoring_bil} placeholder="Enter text here" 
                                      type="text" onBlur={tableMapToReduxHelper} id="i_indv_tutoring_bil"></input>
                            </td>
                          </tr>
                          {/* Row 8 */}
                          <tr>
                            <td>
                              Consultation Services
                            </td>
                            <td>
                              <input defaultValue={assessmentState.i_freq_consulServices_bil} placeholder="Enter text here" 
                                      type="text" onBlur={tableMapToReduxHelper} className id="i_freq_consulServices_bil"></input>
                            </td>
                            <td>
                              <input defaultValue={assessmentState.i_indv_consulServices_bil} placeholder="Enter text here" 
                                      type="text" onBlur={tableMapToReduxHelper} id="i_indv_consulServices_bil"></input>
                            </td>
                          </tr>
                        </table>
                        <br/>
                        <div className='assessment-section-body'>
                          <TextArea_Simple id="i_other_bil" 
                            classesToAdd={""}
                            valueInField={assessmentState.i_other_bil}
                            triggerUpdateInParent={mapToRedux}
                            placeholder="Other." 
                            rows={3} 
                            minrows={3} 
                            maxrows={5} 
                          />
                        </div>
                        <br/>
                      </Col>
                  </Row>

                  {/* ROW J */}
                  <Row>
                      <Col>
                      <p className="assessment-section-headers">
                            J: Speech/Language/Communication
                        </p>
                        <div className='assessment-section-body'>
                          <b>Please check areas with which child has significant difficulty within the classroom:</b>
                          <MultiSelect_Checkbox_Outlined id="areas_bil" 
                            classesToAdd={"required"}
                            valueInField={assessmentState.areas_bil}
                            handleTranslationTypeChanges={handleDiffInClassroomTypesChanges} 
                            triggerUpdateInParent={mapToRedux}
                            label="" 
                            required={true}
                            choices={["Articulation/Intelligibility", "Dysfluencies(ie. stuttering)", 
                            "Comprehension of directions/vocabulary", "Verbal expression", "Maintaining topic relevancy"]} 
                          />
                          <br/>
                          <TextArea_Simple id="addConcerns_bil" 
                            classesToAdd={""}
                            valueInField={assessmentState.addConcerns_bil}
                            triggerUpdateInParent={mapToRedux}
                            placeholder="Additional Concerns." 
                            required={false}
                            rows={3} minrows={3} maxrows={5}
                          />
                        </div>
                        <br/>
                      </Col>
                  </Row>

                  {/* ROW K */}
                  <Row>
                      <Col>
                        <p className="assessment-section-headers">
                            K: Suspension
                        </p>
                        <div className='assessment-section-body'>
                          <p>
                            <b>Has the student ever been suspended from school? (please provide details):</b>
                          </p>
                          <TextArea_Simple id="suspDetails_bil"
                            classesToAdd={"required-adjusted-textarea"}
                            valueInField={assessmentState.suspDetails_bil}
                            triggerUpdateInParent={mapToRedux}
                            placeholder="Details." 
                            required={true}
                            rows={3} minrows={3} maxrows={5}
                          />
                        </div>
                      </Col>
                      
                  </Row>         
                           
                </Col>
              </CardContent>
              </Card>
              </Box>
              </Row>
              
            </Row>
            <Row><Col>&nbsp;</Col></Row>
            <Row><Col>&nbsp;</Col></Row>

          </Container>
          <div className="form-button-bottom-container">
            {/*<Button className="btn btn-primary form-button-bottom" onClick={() => backToPreviousScreen()}
                variant="contained" color="primary">
                Back
            </Button>
            &nbsp;&nbsp;&nbsp;&nbsp;*/}
            <Button className="btn btn-primary form-button-bottom"
              onClick={() => runAllValidations()}
              variant="contained" color="primary">
              Next Page
            </Button>
          </div>
          <br/>
      </FadeIn>
    </div>
    </ThemeProvider>
  )
}

export default BilingualAssessmentContent_Page2
